import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { CTAQueryStateType } from '@sc/data-access-models';
import { CTAQuerySetAction, CTAQueryUnsetAction } from './cta-query.actions';

@State<string>({
  name: 'ctaQuery',
  defaults: null,
})
@Injectable()
export class CTAQueryState {
  @Action(CTAQuerySetAction)
  setCTA(
    ctx: StateContext<CTAQueryStateType>,
    { ctaQuery }: CTAQuerySetAction
  ): void {
    ctx.setState({
      ...ctx.getState(),
      ...ctaQuery,
    });
  }

  @Action(CTAQueryUnsetAction)
  unsetCTA(ctx: StateContext<CTAQueryStateType>): void {
    ctx.setState(null);
  }
}
